module.exports = __webpack_public_path__ + "img/table-1.826567d5.jpg";